import { Store } from 'src/store/index';

const getAllFormats = (store: Store) => store.format.allFormats;

export default getAllFormats;
